import { render, staticRenderFns } from "./InvoiceLinesEditorSimplified.vue?vue&type=template&id=7872bf13&scoped=true&"
import script from "./InvoiceLinesEditorSimplified.vue?vue&type=script&lang=js&"
export * from "./InvoiceLinesEditorSimplified.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceLinesEditorSimplified.vue?vue&type=style&index=0&id=7872bf13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872bf13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VRow})
